function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "204.38",
  height: "160",
  viewBox: "0 0 204.38 160",
  focusable: "false"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a344a022-7881-4c3c-b7a5-ca6e3ee465e0",
  x1: "36.18",
  y1: "14.18",
  x2: "149.73",
  y2: "127.73",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0",
  stopColor: "#35abab"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".7",
  stopColor: "#676e96"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".9",
  stopColor: "#5c568f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#56488b"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "a48c462c-661c-489e-99fd-e38fed2ea7ac",
  "data-name": "New Gradient Swatch 5",
  x1: "101.95",
  y1: "58.07",
  x2: "196.01",
  y2: "152.13",
  gradientTransform: "translate(43.88 252.5) rotate(-90)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0",
  stopColor: "#35abab"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".67",
  stopColor: "#676e96"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".89",
  stopColor: "#5c568f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#56488b"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "a69bbd19-5f44-4076-a7bc-e6225971d68c",
  x1: "104.02",
  y1: "60.15",
  x2: "192.35",
  y2: "148.48",
  xlinkHref: "#a48c462c-661c-489e-99fd-e38fed2ea7ac"
})), /*#__PURE__*/React.createElement("title", null, "graphic_state_multimedia"), /*#__PURE__*/React.createElement("g", {
  style: {
    isolation: "isolate"
  }
}, /*#__PURE__*/React.createElement("g", {
  id: "f18787b6-8ea2-462d-a04b-ed430ef011a5",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M194 0H2a2 2 0 00-2 2v148a2 2 0 002 2h192a2 2 0 002-2V2a2 2 0 00-2-2zM28 143a1 1 0 01-1 1H9a1 1 0 01-1-1v-14a1 1 0 011-1h18a1 1 0 011 1zm0-120a1 1 0 01-1 1H9a1 1 0 01-1-1V9a1 1 0 011-1h18a1 1 0 011 1zm32 120a1 1 0 01-1 1H41a1 1 0 01-1-1v-14a1 1 0 011-1h18a1 1 0 011 1zm0-120a1 1 0 01-1 1H41a1 1 0 01-1-1V9a1 1 0 011-1h18a1 1 0 011 1zm32 120a1 1 0 01-1 1H73a1 1 0 01-1-1v-14a1 1 0 011-1h18a1 1 0 011 1zm0-120a1 1 0 01-1 1H73a1 1 0 01-1-1V9a1 1 0 011-1h18a1 1 0 011 1zm32 120a1 1 0 01-1 1h-18a1 1 0 01-1-1v-14a1 1 0 011-1h18a1 1 0 011 1zm0-120a1 1 0 01-1 1h-18a1 1 0 01-1-1V9a1 1 0 011-1h18a1 1 0 011 1zm32 120a1 1 0 01-1 1h-18a1 1 0 01-1-1v-14a1 1 0 011-1h18a1 1 0 011 1zm0-120a1 1 0 01-1 1h-18a1 1 0 01-1-1V9a1 1 0 011-1h18a1 1 0 011 1zm32 120a1 1 0 01-1 1h-18a1 1 0 01-1-1v-14a1 1 0 011-1h18a1 1 0 011 1zm0-120a1 1 0 01-1 1h-18a1 1 0 01-1-1V9a1 1 0 011-1h18a1 1 0 011 1z",
  fill: "url(#a344a022-7881-4c3c-b7a5-ca6e3ee465e0)"
}), /*#__PURE__*/React.createElement("rect", {
  x: "8",
  y: "32",
  width: "180",
  height: "88",
  rx: "1",
  style: {
    mixBlendMode: "multiply"
  },
  fill: "#193138",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 95.13V119a1 1 0 001 1h178a1 1 0 001-1V94.14a44.94 44.94 0 01-13.58 8.23C138.71 115.91 107.35 71.86 60.94 73c-12.25.31-30.31 3.88-52.15 20.51A2 2 0 008 95.13z",
  fill: "#7ca5cc",
  opacity: ".1"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "159.75",
  cy: "60.54",
  r: "20.54",
  fill: "#7ca5cc",
  opacity: ".1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.83 75a76.87 76.87 0 00-18.89-2c-12.25.31-30.31 3.88-52.15 20.51A2 2 0 008 95.13V119a1 1 0 001 1h115.91a67.62 67.62 0 01-45.08-45z",
  fill: "#7ca5cc",
  opacity: ".1"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: "92.5",
  y: "48.12",
  width: "111.38",
  height: "112.38",
  rx: "2",
  transform: "translate(252.5 -43.88) rotate(90)",
  fill: "url(#a48c462c-661c-489e-99fd-e38fed2ea7ac)"
}), /*#__PURE__*/React.createElement("rect", {
  x: "99.49",
  y: "56.05",
  width: "97.39",
  height: "96.52",
  rx: "1",
  style: {
    mixBlendMode: "multiply"
  },
  fill: "#193138",
  opacity: ".2"
}), /*#__PURE__*/React.createElement("rect", {
  x: "103.64",
  y: "59.36",
  width: "89.1",
  height: "89.9",
  rx: "2",
  transform: "translate(252.5 -43.88) rotate(90)",
  fill: "url(#a69bbd19-5f44-4076-a7bc-e6225971d68c)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: "121.97",
  cy: "78.33",
  rx: "11.24",
  ry: "11.14",
  style: {
    mixBlendMode: "multiply"
  },
  fill: "#193138",
  opacity: ".2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M193.14 84.82l-52.44 52-19-18.62-18.46 18.6v10.06a2 2 0 002 2h85.9a2 2 0 002-2z",
  style: {
    mixBlendMode: "multiply"
  },
  fill: "#193138",
  opacity: ".2"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "multiply"
  },
  fill: "#193138",
  opacity: ".1",
  d: "M121.7 118.18l31.17 30.68H130.4l-8.7-30.68z"
}))))));